var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _path6, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStructureBeatsMotivation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 200 L340 200",
    stroke: "#38bdf8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 200 Q60 120 200 100 Q340 120 340 200",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.4,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 200 L100 160",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeDasharray: "4 4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200 200 L200 130",
    stroke: "#fafcfb",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M300 200 L300 150",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeDasharray: "4 4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 155,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 125,
    r: 8,
    stroke: "#fafcfb",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 145,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 80 Q168 50 200 42 Q232 50 232 80",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 90,
    r: 2,
    fill: "#38bdf8"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 85,
    r: 1.5,
    fill: "#fbbf24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureBeatsMotivation);
export default __webpack_public_path__ + "static/media/structure-beats-motivation.8d84a5a4c983b88e7309e69ba8796b05.svg";
export { ForwardRef as ReactComponent };